<template>

    <form ref="colaboradorformacademica-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-12">
                <label for="nmInstituicao">Instituição</label>
                <input type="text" class="form-control" autocomplete="off" maxlength="80" name="nmInstituicao" v-model="model.nmInstituicao" required />
            </div>
            <div class="form-group col-md-12">
                <label for="nmCurso">Curso</label>
                <input type="text" class="form-control" autocomplete="off" name="nmCurso" maxlength="80" v-model="model.nmCurso" required />
            </div>
            <div class="form-group col-md-12">
                <label for="situacaoCurso">Situação</label>
                <select v-model="model.situacaoCurso" class="form-control" autocomplete="off" name="situacaoCurso" required>
                    <option value="A">Em Andamento</option>
                    <option value="C">Completo</option>
                    <option value="I">Incompleto</option>
                </select>
            </div>
            <div class="form-group col-md-12">
                <label for="anoConclusao">Ano de Conclusão</label>
                <input type="number" class="form-control" autocomplete="off" name="anoConclusao" min="0" max="2099" v-mask="'####'" v-model="model.anoConclusao" required />
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaboradorformacademica-form-create",
        props: { colaboradorId: Number },
        mixins: [base],
        data: () => ({

            model: {},

            form: "colaboradorformacademica-form-create",

            resources: {
                create: 'colaboradorformacademica',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                model.colaboradorId = this.colaboradorId;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

